<template lang="pug">
  mixin orderSummary(num)
    dl.p-checkout-order-detail
      // Product Subtotal
      dt
        | Product Subtotal
      dd.u-align-right
        | {{ cart.product_subtotal | currency }}

      // Gift Wrapping Charge
      template(v-if="cart.gift_wrapping_charge")
        dt Gift Wrapping
        dd.u-align-right {{ cart.gift_wrapping_charge | currency }}

      // Membership Fee
      template(v-if="premium.is_joining && user.possible_premium_plan_type && premiumPlan.type[user.possible_premium_plan_type].price.value > 0")
        dt
          .u-flex.u-flex-ai-center
            img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mrxs(
            :src="'/images/tom_premium_h.svg' | staticImageUrl",
            style="height: 15px",
            alt="TOM Premium"
            )
            template(v-if='user.can_buy_with_annual_plan')
              | Annual Fee
            template(v-else)
              | Membership Fee
        dd.u-align-right {{ premiumPlan.type[user.possible_premium_plan_type].price.value | currency }}

      template(v-if="discountTotal > 0")
        dt Discounts
          | &nbsp;
          span(v-if="openDiscounts" + num)
            | &lt;
          span(v-else)
            | &gt;
          a(href='#', @click.prevent="toggleDiscounts" + num)
            span(v-if="openDiscounts" + num)
              | Close details
            span(v-else)
              | See details
        dd.u-align-right {{ (discountTotal * -1) | currency }}

      template(v-if="openDiscounts" + num)
        // Product Discount
        template(v-if='cart.sku_discount_price_total > 0')
          dt
            .u-flex.u-flex-ai-center
              template(v-if='cart.sku_premium_discount_price_total > 0')
                img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mrxs(
                :src="'/images/tom_premium_h.svg' | staticImageUrl",
                style="height: 15px",
                alt="TOM Premium"
                )
              span Product Discount
          dd.u-align-right.p-checkout-text--discount {{ (cart.sku_discount_price_total * -1)| currency }}

        // Welcome Discount
        template(v-if="premium.is_joining && ShoppingCarts.welcomeDiscount(cart, user)")
          dt
            .u-flex.u-flex-ai-center
              img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mrxs(
              :src="'/images/tom_premium_h.svg' | staticImageUrl",
              style="height: 15px",
              alt="TOM Premium"
              )
              span(v-if='user.can_buy_with_annual_plan') Annual Discount
              span(v-else) Welcome {{ ShoppingCarts.isPremiumRecontractPlan(user) ? 'Back Discount' : 'Discount' }}
          dd.u-align-right.p-checkout-text--discount {{ ShoppingCarts.welcomeDiscount(cart, user) * -1 | currency }}

        //- Recontract Extra Discount - P会員再入会インセンティブ
        template(v-if="premium.is_joining && premiumWillGainRecontractExtraDiscount")
          dt
            .u-flex.u-flex-ai-center
              img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mrxs(
              :src="'/images/tom_premium_h.svg' | staticImageUrl",
              style="height: 15px",
              alt="TOM Premium"
              )
              span Recontract Extra Discount
          dd.u-align-right.p-checkout-text--discount {{ premiumWillGainRecontractExtraDiscount * -1 | currency }}

        //- Subscription Incentive
        template(v-if="!premium.is_joining && user.is_premium_member && ShoppingCarts.contractIncentiveDiscount(cart)")
          dt
            .u-flex.u-flex-ai-center
              img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mrxs(
              :src="'/images/tom_premium_h.svg' | staticImageUrl",
              style="height: 15px",
              alt="TOM Premium"
              )
              span Subscription Incentive
          dd.u-align-right.p-checkout-text--discount {{ ShoppingCarts.contractIncentiveDiscount(cart) * -1 | currency }}

        // Coupon
        template(v-if='!!coupon')
          dt(:class="{'p-checkout-coupon-free-shipping-name': coupon.is_shipping_free}")
            span.coupon_name(v-text='coupon.display_name')

          dd.p-checkout-coupon-free-shipping-label(v-if='coupon.is_shipping_free')
            span.c-label.c-label--sm.c-label--free-shipping Free Standard Shipping

          dd.u-align-right.p-checkout-text--discount(v-else)
            span
              | {{(cart.discount_real_price_with_coupon * -1) | currency}}
            strike.u-block.u-color-muted(v-if='cart.discount_real_price_with_coupon < cart.discount_price_with_coupon') {{(cart.discount_price_with_coupon * -1) | currency}}

        // TOM Points
        template(v-if='cart.point > 0')
          dt TOM Points
          dd.u-align-right.p-checkout-text--discount {{ (cart.point * -1) | currency }}

        template(v-if='cart.reserved_point')
          dt Reserved TOM Points
          dd.u-align-right.p-checkout-text--discount {{(cart.reserved_point * -1) | currency}}

      // Shipping
      template(v-if='cart.shipping_charge > 0')
        dt Shipping
        dd.u-align-right {{ cart.shipping_charge ? cart.shipping_charge : 0 | currency }}

      // Import fee
      template(v-if='cart.import_fees > 0')
        dt
          | Import Fees
          a.link--inherit.u-mlxs(href="#", @click.prevent="openImportFeesModal")
            i.icon-question-sign
        dd.u-align-right {{ cart.import_fees | currency }}

    dl.p-checkout-order-detail
      // Grand Total
      dt.p-checkout-total.u-weight-bold.u-fs-xl Grand Total
      dd.u-align-right.u-weight-bold.u-fs-xl {{ cart.grand_total_for_cart_page | currency }}

    dl.p-checkout-order-detail.p-checkout-order-detail-border
      // Points Reward
      dt.small.u-mb0
        | TOM Points Earned
      dd.u-align-right.u-mb0
        i.icon-tom-point.u-color--point-lv2
        span.u-fs-md.u-weight-normal {{ cart.acquire_point }}

  .v-container(:class="containerLoadingClass")
    .row
      .col.s12
        //- messageForDelivery.cart
        template(v-if="messageForDelivery.cart.length")
          .p-review-message--primary.c-message.c-message--spacious.c-message--warn.u-mt0.u-mbm(v-for="message in messageForDelivery.cart")
            p.h5.c-message__header.u-mbxs(v-text="message.title", v-if="message.title")
            p(v-html="message.text")

        //- messageForDelivery.maihama
        template(v-if="messageForDelivery.maihama.length && Shipments.hasMaihamaShipment(shipments)")
          .p-review-message--primary.c-message.c-message--spacious.c-message--warn.u-mt0.u-mbm(v-for="message in messageForDelivery.maihama")
            p.h5.c-message__header.u-mbxs(v-text="message.title", v-if="message.title")
            p(v-html="message.text")

        //- messageForDelivery.us
        template(v-if="messageForDelivery.us.length && Shipments.hasUSShipment(shipments)")
          .p-review-message--primary.c-message.c-message--spacious.c-message--warn.u-mt0.u-mbm(v-for="message in messageForDelivery.us")
            p.h5.c-message__header.u-mbxs(v-text="message.title", v-if="message.title")
            p(v-html="message.text")

        //- messageForDelivery.pendingByCoronaVirusCountries
        template(v-if="Shipments.hasInStockSku(shipments) && Shipments.hasMaihamaShipment(shipments) && Shipments.hasEMSOrAirSPRInSelectableShippingMethods(shipments)")
          vue-collapsable-messages.p-review-message--primary(
            v-if="messageForDelivery.pendingByCoronaVirusCountriesEMSAndAir.length && messageForDelivery.pendingByCoronaVirusCountriesEMSAndAir.includes(currentShipping.country)",
            collapsed-text='Important Notice Regarding Shipping Delays',
            expanded-title='WARNING:'
            :expanded-body="`Japan Post has temporarily suspended some shipments to your country, but we can make alternate arrangements to send your items. <a href=\"${isShippingToUs ? 'https://otakumode.com/hc/shop/service_alerts/shipping/694a431b55e361001ec61482' : '/shop/pickup/service-alerts'}\" target=\"_blank\">More info here</a>.`"
            :expand-once='true'
            expand-cookie-key='shipping_notice_to_corona_virus_countries_ems_202005'
          )
        template(v-if='Shipments.hasMaihamaShipment(shipments) && messageForDelivery.pendingByCoronaVirusCountriesAll.length && messageForDelivery.pendingByCoronaVirusCountriesAll.includes(currentShipping.country)')
          vue-collapsable-messages.p-review-message--primary(
            v-if="currentShipping.country !== 'CA'",
            collapsed-text='Important Notice Regarding Shipping Delays',
            expanded-title='NOTE:'
            :expanded-body="`Japan Post has temporarily suspended shipments to your country. Items will be held for you in our warehouse until shipments resume. <a href=\"${isShippingToUs ? 'https://otakumode.com/hc/shop/service_alerts/shipping/694a431b55e361001ec61482' : '/shop/pickup/service-alerts'}\" target=\"_blank\">More info here</a>.`"
            :expand-once='true'
            expand-cookie-key='shipping_notice_to_corona_virus_countries_all_202005'
          )


    .row(v-if="shipments.length")
      .col.s12
        .u-flex.u-flex-jc-space_between.u-mbm.u-mtm
          h1.h3.u-weight-bold.u-flex
            | {{ ShoppingCarts.isGiftFromWishList(cart) ? 'Review Your Gift Order' : 'Review your order'}}
            .u-fs-sm.u-mls.u-flex.u-flex-ai-center(v-if='!user.is_smart_phone_device && ShoppingCarts.isGiftFromWishList(cart)', style="color: #888;")
              i.icon-arrow-right.u-mrxs
              img.u-img--round.u-mrxs(
                :src='wishlistUserAvatarImageSrc | webp',
                width='16',
                height='16',
                alt='',
                @error="setDummyAvatar"
              )
              span {{cart.wishlist_user.name}}
          .u-flex.u-flex-ai-end(v-if="cart && cart.expiration_seconds")
            span.p-cart-reserved__time Reserved for:
            time.p-cart-reserved__time.u-mlxs(v-text='expirationMinutes')
            span.u-fs-sm.u-color-gray(style="margin-left: 2px;") min
            a.u-mlxs.c-tooltip.c-tooltip--w.u-valign-middle.u-block--md.u-block--lg.u-block--xl(:data-tooltip="cartReservedTimerTooltipText"): i.icon-time

        .p-cart__for-wishlist.u-border-none.u-mbm(v-if="user.is_smart_phone_device && ShoppingCarts.isGiftFromWishList(cart)")
          span For
          img.u-img--round.u-mls.u-mrs(
            :src='wishlistUserAvatarImageSrc | webp',
            width='24',
            height='24',
            alt='',
            @error="setDummyAvatar"
          )
          span {{ cart.wishlist_user.name }}

    .p-checkout-container.row.row--flex
      .p-checkout-main.col.s8
        .p-review-inner.u-mbm.u-block--sm
          +orderSummary(1)

          .p-tos.small.u-mtxs.
            By placing your order, you agree to our #[a(href="/tos", target="_blank") terms of use] and #[a(href="/privacy_guide_checkout", target="_blank") privacy policy].

          // CA向けFEDEXの注意文を表示
          .c-message.c-message--warn.c-message--sm.u-mtxs(v-if="isDisplayCanadaFedexMessage")
            .c-message__body
              span Payment of additional customs fees may be required before delivery. FedEx will contact you if this is the case. Customs fees are NOT included in your Grand Total.

          vue-checkout-button(:switch-user="switchUser", @start-loading="startLoading", @stop-loading="stopLoading", amazon-widget-unique-id="1", :hide-by-placing-your-order="true")

        .p-review-message.c-message.c-message--danger.u-mt0.u-mbm(v-if="Shipments.hasUndeliverableItemInShipments(shipments)")
          p One or more of the items in your cart cannot be delivered to the country specified in your shipping address.

        .p-review-message.c-message.c-message--danger.u-mt0.u-mbm(v-if="willJoinPremium && !hadRegisteredPremiumInPast && !canGetBonus")
          p This payment method is already linked to another account. Please know any orders paid for by this payment method will not include first-time purchaser benefits of any kind in relation to TOM services.

        .p-review-message.c-message.c-message--warn.u-mt0.u-mbm(v-if="isUnderFreeShippingThresholdAtUsingCoupon || isUnderFreeShippingThresholdAtUsingPoint")
          p
            i.icon-tom-track.u-mrxs
            | If your subtotal falls below ${{cart.free_shipping_threshold}}, your order will not be eligible for free shipping.

        .p-review-info
          .p-review-info-box.c-panel
            .c-panel__header
              .u-flex.u-flex-jc-space_between.u-flex-ai-center
                .u-weight-bold
                  template(v-if="ShoppingCarts.isDigitalProductsOnly(cart)") Billing Address
                  template(v-else) Shipping Address
                router-link.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm(to='/checkout/shippings', v-if="!ShoppingCarts.isGiftFromWishList(cart)") Change

            .c-panel__body
              // Wishlist経由の購入の場合
              template(v-if="ShoppingCarts.isGiftFromWishList(cart)")
                p Ship to #[strong {{cart.wishlist_user.name}}]

              // 住所がある場合
              template(v-else-if="currentShipping")
                p.strong(v-if="currentShipping.label") {{currentShipping.label}}
                p.strong(v-if="currentShipping.name") {{currentShipping.name}}
                p(:inner-html.prop="currentShipping | formatAddress | nl2br")

              // 住所がない場合
              template(v-else)
                p Please add a shipping address

          .p-review-info-box.c-panel
            .c-panel__header
              .u-flex.u-flex-jc-space_between.u-flex-ai-center
                .u-weight-bold Payment Method
                router-link.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm(to='/checkout/payments', v-if="!(Payment.isBypass(currentPayment) && !!switchUser) && !cart.unavailable_payment_methods.includes('stripe')") Change

            .c-panel__body
              // 支払い情報がある場合
              template(v-if="currentPayment && currentPayment.method")
                // Manual Order
                template(v-if='Payment.isBypass(currentPayment) && !!switchUser')
                  p Bypass
                template(v-else)
                  img(:src='currentPaymentImagePath.src | resizedImageUrl(null, null, { type: "bypass" }) | webp', width='48')
                  span.bold.u-mlxs(v-text="currentPaymentLabel")

              // 支払い情報がない場合
              template(v-else)
                p Select a Payment Method

          template(v-if="!ShoppingCarts.isGiftFromWishList(cart) && !ShoppingCarts.hasDigitalContentGift(cart) && !ShoppingCarts.isAllItemPointOnlyPurchase(cart)")
            .p-review-info-box.c-panel(v-if="pointToDollar > 0")
              .c-panel__header
                .u-flex.u-flex-jc-space_between.u-flex-ai-center
                  .u-weight-bold TOM Points
                  // ポイント利用不可の商品が含まれない場合
                  template(v-if="cart.can_use_point")
                    button.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm(type="button", @click="openPointModal") Change

              .c-panel__body
                // ポイント利用不可の商品が含まれない場合
                .u-weight-bold(v-if="cart.can_use_point")
                  | TOM Points applied:
                  span.u-color--point-lv2.bold.u-mlxs.u-mrxs {{cart.point | currency}}
                // ポイント利用不可の商品が含まれる場合
                .u-weight-bold(v-else) TOM Points cannot be used on this order.

                div
                  | TOM Points remaining:
                  span.u-mlxs.u-mrxs {{(ShoppingCarts.availablePoint(cart, user) - cart.point) | currency}}
                div(v-if="cart.reserved_point")
                  | TOM Points reserved:
                  span.u-color--point-lv2.bold.u-mlxs.u-mrxs {{ cart.reserved_point | currency }}

            .p-review-info-box.c-panel(v-if='!ShoppingCarts.hasPointOnlyProduct(cart)')
              .c-panel__header
                .u-flex.u-flex-jc-space_between.u-flex-ai-center
                  .u-weight-bold Coupon
                  button.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm(type="button", @click="openCouponsModal") Change

              .c-panel__body
                // 現在適用中のクーポンがある場合
                template(v-if="!!coupon")
                  .u-weight-bold {{coupon.display_name}}

                  // Free Shippingクーポンの場合
                  .u-weight-bold(v-if="coupon.is_shipping_free")
                    | FREE STANDARD SHIPPING
                    br
                  // 割引クーポンの場合
                  .p-price--discount.u-weight-bold(v-if="coupon.display_off")
                    | {{coupon.display_off}} OFF

                // 現在適用中のクーポンがない場合
                template(v-else)
                  .u-weight-bold None selected

        section.p-checkout-section.u-mbm(v-for="(shipment, index) in shipments")
          h2.p-checkout-section__title
            div(v-if="Shipments.hasDigitalContent(shipment)")
              | Digital Content
            div(v-else)
              | Shipment {{index + 1}}
              span.u-fs-md.u-mlxs(style="color: #777777;") {{ShoppingCarts.shippingFrom(shipment)}}
            div(v-if="!Shipments.hasDigitalContentGift(shipment)")
              a.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm(:href="cartURL") Edit
          .p-shipment-info
            .p-shipment-item(:class="{'p-shipment-item-fill': (Shipments.hasDigitalContent(shipment) || Shipments.hasUndeliverableItem(shipment))}")
              .p-checkout-section__content(v-for="item in shipment.items")
                template(v-if='ProductSku.isUndeliverableSku(item.sku)')
                  .c-message.c-message--danger.u-mt0
                    span This item cannot be delivered to the country specified in your shipping address.

                .u-flex
                  figure.p-shipment-figure
                    vue-image-overlay-zoom(
                      v-if="item.variation && item.variation._id",
                      :sku-no="item.sku.no",
                      :front="item.variation.imageUrl",
                    )
                    img.u-img--circle(v-else, :src='item.sku.image.source | resizedImageUrl(64, 64) | webp')
                  .p-shipment-body
                    h3.p-checkout__subtitle.p-shipment-body__title
                      a(v-if="item.variation && item.variation._id", :href='item.variation.detailUrl' target="_blank") [{{item.variation.title}}] {{ProductSku.fullTitleEnPreferred(item.sku)}}
                      a(v-else, :href='"/shop/" + item.product' target="_blank") {{ProductSku.fullTitleEnPreferred(item.sku)}}
                    .p-shipment-price.u-mts
                      span.p-shipment-price--regular.u-mrxs(v-if='ProductSku.isSale(item.sku)') {{ProductSku.getRegularPrice(item.sku, user) | currency}}
                      span.p-shipment-price--selling.u-mrxs {{ProductSku.getSellingPrice(item.sku, user) | currency}}
                      img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mr0(
                      v-if="isPremiumMember && (item.sku.prices.premium && (item.sku.prices.premium.price > 0))",
                      :src="'/images/tom_premium_h.svg' | staticImageUrl",
                      style="height: 15px",
                      alt="TOM Premium"
                      )
                    .p-shipment-qty.u-mtxs
                      label Quantity: {{item.qty}}
                      button.c-btn.c-btn--primary-invert.c-btn--round.c-btn--sm.u-mls(type="button", @click="removeItem(shipment._id, item.sku._id)", v-if='ProductSku.isUndeliverableSku(item.sku)') Remove
                    .u-mtxs(v-if="item.sku.sales_method === 'bto' || item.sku.sales_method === 'pre_order'")
                      template(v-if="item.sku.sales_method === 'bto'")
                        .c-label.c-label--info.c-label--round Special Order
                        p.small.u-mtxs
                          i.icon-exclamation-sign.u-mrxs
                          | Special order products cannot be canceled.
                      template(v-if="item.sku.sales_method === 'pre_order'")
                        .u-flex.u-flex-ai-center
                          .c-label.c-label--info.c-label--round Pre-order
                          span.small.u-mlxs(v-if="item.sku.expected_ship_at")
                            | Release Month : {{item.sku.format_expected_ship_at_or_extra_week}}
                        p.small.u-mtxs
                          i.icon-exclamation-sign.u-mrxs
                          | Pre-order products cannot be canceled.
                    .u-mtxs(v-if='item.sku.flags.point_disabled')
                      p.small
                        i.icon-exclamation-sign.u-mrxs
                        | TOM Points cannot be used on orders containing this item.
                    .u-mtxs(v-if='item.sku.flags.point_only')
                      p.small
                        i.icon-exclamation-sign.u-mrxs
                        | This is a Premium Point Reward item.
                    template(v-if='item.gift && item.gift.receiver && item.gift.receiver.name && item.gift.receiver.email')
                      p Recipient Name: {{item.gift.receiver.name}}
                      p Recipient's Email: {{item.gift.receiver.email}}
                      p Gift Delivery Date: {{formatDate(item.gift.will_send_at)}}
                    template(v-if='!item.is_divided && shipment.items.length > 1 && item.sku.sales_method === "pre_order"')
                      .u-mtxs.u-fs-sm
                        a(href='javascript:void(0);', @click='divideSkuFromShipment(shipment._id, item.sku._id)') Ship this item separately
                    template(v-if='item.is_divided && shipment.items.length == 1')
                      .u-mtxs.u-fs-sm
                        a(href='javascript:void(0);', @click='combineSkuToShipment(shipment._id, item.sku._id)') Ship together with other items

            .p-shipment-option(v-if="!Shipments.hasDigitalContent(shipment) && !Shipments.hasUndeliverableItem(shipment)")
              .p-checkout-section__content
                .p-shipping-method
                  h3.p-checkout__subtitle Shipping Method
                  .c-message.c-message--error(v-if="Shipments.isNoShippingMethodForMangaPlus(shipment)")
                    p There are currently no shipping methods available for your order. We apologize for any inconvenience this may cause.
                    p Please try again later or contact us for more information.
                  .p-shipment-option-body(v-else)
                    vue-shipping-methods(:shipment="shipment")

                .u-mtm(v-if="shipment.import_fees > 0")
                  h3.p-checkout__subtitle
                    | Import Fees
                    a.link--inherit.u-mlxs(href="#", @click.prevent="openImportFeesModal")
                      i.icon-question-sign
                  .u-mtxs {{shipment.import_fees | currency}}

      .p-checkout-side.col.s4.u-pbs
        .p-checkout-order
          vue-checkout-button(:switch-user="switchUser", @start-loading="startLoading", @stop-loading="stopLoading", amazon-widget-unique-id="2", :hide-by-placing-your-order="true")

        .p-checkout-order-premium.small(v-if="(user.is_premium_member === false || user.can_buy_with_annual_plan) && user.possible_premium_plan_type")
          vue-join-toggle-premium(
            :is_joining='premium.is_joining',
            :is_premium_first_plan='ShoppingCarts.isPremiumFirstPlan(user)',
            :premium_joiing_save_price='ShoppingCarts.premiumJoiningSavePrice(cart, user)',
            :value='premiumPlan.type[user.possible_premium_plan_type].price.value',
            :term='premiumPlan.type[user.possible_premium_plan_type].term',
            :change='togglePremiumJoin',
            :can_buy_with_annual_plan='user.can_buy_with_annual_plan'
          )
          | &nbsp;
          vue-whats-tom-premium.u-mts.u-inline-block(
            name='whats-tom-premium',
            :is_smart_phone_device='user.is_smart_phone_device',
            :plan_type='user.possible_premium_plan_type',
            :plan='premiumPlan',
            :check_payment_methods='user.has_waiting_auto_recurring_premium',
            :is_icon_only='true',
            :can_buy_with_annual_plan='user.can_buy_with_annual_plan'
          )

        .p-checkout-order-contents
          +orderSummary(2)

        .p-by-placing-your-order.p-tos.small.u-mtxs.
          By placing your order, you agree to our #[a(href="/tos", target="_blank") terms of use] and #[a(href="/privacy_guide_checkout", target="_blank") privacy policy].

        // CA向けFEDEXの注意文を表示
        .c-message.c-message--warn.c-message--sm.u-mtxs.u-mbs(v-if="isDisplayCanadaFedexMessage")
          .c-message__body
            span Payment of additional customs fees may be required before delivery. FedEx will contact you if this is the case. Customs fees are NOT included in your Grand Total.

</template>

<script>
import { BigNumber } from 'bignumber.js';
import ShoppingCarts from '../../../stores/schema/ShoppingCarts';
import ProductSku from '../../../stores/schema/ProductSku';
import Shipments from '../../../stores/schema/injected/Shipments';
import { Payment } from '../../../stores/schema/Payment';
import { SHIPPING_METHODS } from '../../../../../../../lib/document/schema/shipping_method';

import urlUtil from '../../../util/url';
import textUtil from '../../../util/text';
import addressUtil from '../../../util/address';

import checkoutButtonComponent from '../../../components/checkout/checkoutButton.vue';
import importFeesComponent from '../../../components/checkout/importFees.vue';
import whatsTomPremiumComponent from '../../../components/shop/cart/whatsTomPremium.vue';
import joinTogglePremiumComponent from '../../../components/shop/cart/joinTogglePremium.vue';
import shippingMethodsComponent from '../../../components/checkout/shipping_methods.vue';
import collapsableMessagesComponent from '../../../components/messages/CollapsableMessages.vue';
import imageOverlayZoomComponent from '../../../components/common/imageOverlayZoom.vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default {
  name: 'review_order',
  props: {
    switchUser: {
      type: String
    },
    hasValidEmail: {
      type: Boolean
    },
    messageForDelivery: {
      type: Object
    }
  },
  data() {
    return {
      firstLoading: true,
      loading: false,
      openDiscounts1: false,
      openDiscounts2: false
    };
  },
  filters: {
    currency: textUtil.currency,
    webp: urlUtil.webp,
    resizedImageUrl: urlUtil.resizedImageUrl,
    cloudImageUrl: urlUtil.cloudImageUrl,
    nl2br: textUtil.nl2br,
    formatAddress: addressUtil.format,
    staticImageUrl: urlUtil.staticImageUrl
  },
  components: {
    'vue-checkout-button': checkoutButtonComponent,
    'vue-whats-tom-premium': whatsTomPremiumComponent,
    'vue-join-toggle-premium': joinTogglePremiumComponent,
    'vue-shipping-methods': shippingMethodsComponent,
    'vue-collapsable-messages': collapsableMessagesComponent,
    'vue-image-overlay-zoom': imageOverlayZoomComponent
  },
  computed: {
    containerLoadingClass() {
      return {
        'c-loading': !this.shipments.length || this.loading,
        'c-loading--opacity': !this.shipments.length || this.loading
      };
    },
    wishlistUserAvatarImageSrc() {
      return this.cart.wishlist_user.avatar_image
        ? this.cart.wishlist_user.avatar_image
        : this.conf.path.resize + 'bypass/static/common/transparent.png';
    },
    cartReservedTimerTooltipText() {
      return (
        'Stock held in cart will clear only after ' +
        window.conf.cart.expire_minute +
        ' min. of no activity on the site.' +
        '\n' +
        'Refresh page or edit cart to reset timer.'
      );
    },
    cartURL() {
      const param = this.cart.wishlistId ? `?wl=${this.cart.wishlistId}` : '';
      return `/cart${param}`;
    },
    conf() {
      return window.tom.conf;
    },
    user() {
      return this.$store.state.user;
    },
    cart() {
      return this.$store.getters['cart/current']({
        populate: ['shipments', 'discount', 'discount.coupon']
      });
    },
    coupon() {
      return this.cart.discount && this.cart.discount.coupon;
    },
    pointToDollar() {
      return window.tom.user.pointAccount.pointToDollar;
    },
    currentShipping() {
      return this.$store.getters['shippings/current'];
    },
    currentPayment() {
      return this.$store.getters['payments/current'];
    },
    currentPaymentImagePath() {
      return this.$store.getters['payments/getPaymentMethodImagePath'](
        this.currentPayment
      );
    },
    currentPaymentLabel() {
      return this.$store.getters['payments/getPaymentMethodLabel'](
        this.currentPayment
      );
    },
    premium() {
      return this.cart.premium;
    },
    premiumPlan() {
      return this.$store.getters['premiumPlans/findOne']({
        _id: this.cart.premium.plan
      });
    },
    premiumWillGainRecontractExtraDiscount() {
      if (!this.cart) return 0;
      return this.cart.premium_will_gain_recontract_extra_discount;
    },
    shipments() {
      if (!this.cart) return [];
      return this.cart.shipments;
    },
    productIds() {
      const productIds = [];
      this.shipments.forEach((shipment) => {
        shipment.items.forEach((item) => {
          productIds.push(item.product);
        });
      });
      return productIds;
    },

    willJoinPremium() {
      return !!this.user.will_join_premium;
    },

    canGetBonus() {
      return (
        this.cart.premium.can_get_bonus &&
        this.currentPayment &&
        !this.currentPayment.already_used_for_premium
      );
    },

    hadRegisteredPremiumInPast() {
      return !!this.user.had_registered_premium_in_past;
    },

    // カートが expire するまでの残り分数
    expirationMinutes() {
      return Math.ceil(this.cart.expiration_seconds / 60);
    },

    Shipments() {
      return Shipments;
    },

    Payment() {
      return Payment;
    },

    ProductSku() {
      return ProductSku;
    },
    ShoppingCarts() {
      return ShoppingCarts;
    },
    isPremiumMember() {
      return this.user.is_premium_member || this.premium.is_joining;
    },
    // クーポンの使用によって送料が無料でなくなったかどうかを判定
    // 下記2つの条件を満たせばクーポンの使用によって送料無料でなくなったかどうかが分かる
    // 1. クーポン適用前の金額が送料無料の閾値を超えているか
    // 2. クーポン適用後の金額が送料無料の閾値を下回っているか
    // ※ただしFree Shippingクーポンが使用されている場合は除く
    isUnderFreeShippingThresholdAtUsingCoupon() {
      // Free Shippingクーポンが使用されている場合
      if (this.coupon && this.coupon.is_shipping_free) {
        return false;
      }

      // 加工（クーポンやポイントによる値引き）前のアイテム合計金額
      let subtotal = new BigNumber(this.cart.order_subtotal);

      const giftWrappingCharge = new BigNumber(this.cart.gift_wrapping_charge);
      const discountRealPriceWithCoupon = new BigNumber(
        this.cart.discount_real_price_with_coupon
      );
      const tomPoint = new BigNumber(this.cart.point);

      // クーポン適用前の金額
      subtotal = subtotal.plus(giftWrappingCharge).minus(tomPoint);

      // クーポン適用後の金額
      const subtotalWithCoupon = subtotal.minus(discountRealPriceWithCoupon);

      return (
        // クーポン適用前の金額が送料無料の閾値を超えているか
        subtotal.toNumber() >= this.cart.free_shipping_threshold &&
        // クーポン適用後の金額が送料無料の閾値を下回っているか
        subtotalWithCoupon.toNumber() < this.cart.free_shipping_threshold
      );
    },

    // TOMポイントの使用によって送料が無料でなくなったかどうかを判定
    // 下記2つの条件を満たせばクーポンの使用によって送料無料でなくなったかどうかが分かる
    // 1. ポイント適用前の金額が送料無料の閾値を超えているか
    // 2. ポイント適用後の金額が送料無料の閾値を下回っているか
    isUnderFreeShippingThresholdAtUsingPoint() {
      // 加工（クーポンやポイントによる値引き）前のアイテム合計金額
      let subtotal = new BigNumber(this.cart.order_subtotal);

      const giftWrappingCharge = new BigNumber(this.cart.gift_wrapping_charge);
      const discountRealPriceWithCoupon = new BigNumber(
        this.cart.discount_real_price_with_coupon
      );
      const tomPoint = new BigNumber(this.cart.point);

      // ポイント適用前の金額
      subtotal = subtotal
        .plus(giftWrappingCharge)
        .minus(discountRealPriceWithCoupon);

      // ポイント適用後の金額
      const subtotalWithPoint = subtotal.minus(tomPoint);

      return (
        // ポイント適用前の金額が送料無料の閾値を超えているか
        subtotal.toNumber() >= this.cart.free_shipping_threshold &&
        // ポイント適用後の金額が送料無料の閾値を下回っているか
        subtotalWithPoint.toNumber() < this.cart.free_shipping_threshold
      );
    },

    isShippingToUs() {
      return this.currentShipping && this.currentShipping.country === 'US';
    },

    discountTotal() {
      let discount = new BigNumber(0);

      const skuDiscount = this.cart.sku_discount_price_total || 0;
      if (skuDiscount > 0) {
        discount = discount.plus(new BigNumber(skuDiscount));
      }

      if (this.premium.is_joining) {
        const welcomeDiscount =
          ShoppingCarts.welcomeDiscount(this.cart, this.user) || 0;
        const premiumWillGainRecontractExtraDiscount =
          this.premiumWillGainRecontractExtraDiscount || 0;
        discount = discount
          .plus(new BigNumber(welcomeDiscount))
          .plus(new BigNumber(premiumWillGainRecontractExtraDiscount));
      } else if (this.user.is_premium_member) {
        const contractIncentiveDiscount =
          ShoppingCarts.contractIncentiveDiscount(this.cart) || 0;
        discount = discount.plus(new BigNumber(contractIncentiveDiscount));
      }

      if (this.coupon) {
        const couponDiscount = this.cart.discount_real_price_with_coupon || 0;
        discount = discount.plus(new BigNumber(couponDiscount));
      }

      if (this.cart.point > 0) {
        const point = this.cart.point || 0;
        discount = discount.plus(new BigNumber(point));
      }

      if (this.cart.reserved_point) {
        const reservedPoint = this.cart.reserved_point || 0;
        discount = discount.plus(new BigNumber(reservedPoint));
      }

      return discount.toNumber();
    },

    isDisplayCanadaFedexMessage() {
      if (!(this.shipments && this.shipments.length)) {
        return false;
      }

      const selectedShippingMethods = this.shipments.map((shipment) => {
        const selected = shipment.shipping_charges.find(
          (shippingCharge) => shippingCharge.selected
        );
        return selected && selected.shipping_method;
      });
      if (!(selectedShippingMethods && selectedShippingMethods.length)) {
        return false;
      }

      return (
        this.currentShipping &&
        this.currentShipping.country === 'CA' &&
        (selectedShippingMethods.includes(
          SHIPPING_METHODS.FEDEX_PRIORITY.value
        ) ||
          selectedShippingMethods.includes(SHIPPING_METHODS.FEDEX_ICP.value))
      );
    }
  },
  mounted() {
    if (!this.hasValidEmail) {
      this.$nextTick(() => {
        this.$alert(
          'Whoops! Please make sure you have a valid email address registered before continuing.',
          {
            ok: 'Email Settings',
            noCloseOnConfirm: true
          }
        ).then(() => {
          window.location.href = '/settings';
        });
      });
    }
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    removeItem(shipment_id, item_id) {
      this.$confirm('Are you sure you want to delete this item?')
        .then(() => {
          this.changeQty({
            shipment_id,
            item_id,
            qty: 0,
            wishlist_id: this.cart.wishlistId
          });
        })
        .catch((err) => {
          this.$alert(
            (err.errors && err.errors.general) ||
              err ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    },
    openImportFeesModal() {
      this.$modal.show(
        importFeesComponent,
        {
          shippingAddress: this.currentShipping
        },
        {
          width: '90%',
          height: 'auto',
          maxWidth: 960,
          adaptive: true,
          scrollable: true,
          clickToClose: false
        }
      );
    },
    toggleDiscounts1() {
      this.openDiscounts1 = !this.openDiscounts1;
    },
    toggleDiscounts2() {
      this.openDiscounts2 = !this.openDiscounts2;
    },
    openCouponsModal() {
      this.$router.push('/checkout/review/coupons');
    },
    openGiftWrappingModal(shipment_id) {
      this.$router.push(`/checkout/review/gift-wrapping/${shipment_id}`);
    },
    openPointModal() {
      this.$router.push('/checkout/review/points');
    },
    divideSkuFromShipment(shipment_id, sku_id) {
      this.loading = true;
      return this.$store
        .dispatch('cart/divideSkuFromShipment', {
          cart_id: this.cart._id,
          shipment_id: shipment_id,
          sku_id: sku_id
        })
        .then(() => {
          tom.helper.ga.push([
            'event',
            'Checkout',
            'DivideSkuChecked',
            shipment_id,
            1,
            true
          ]);
        })
        .catch((err) => {
          this.$alert(
            (err.errors && err.errors.general) ||
              err ||
              'An error occurred. Please wait a moment before trying again.'
          );
        })
        .then(() => {
          this.loading = false;
        });
    },
    combineSkuToShipment(shipment_id, sku_id) {
      this.loading = true;
      return this.$store
        .dispatch('cart/combineSkuToShipment', {
          cart_id: this.cart._id,
          shipment_id: shipment_id,
          sku_id: sku_id
        })
        .then(() => {
          tom.helper.ga.push([
            'event',
            'Checkout',
            'combineSkuChecked',
            shipment_id,
            1,
            true
          ]);
        })
        .catch((err) => {
          this.$alert(
            (err.errors && err.errors.general) ||
              err ||
              'An error occurred. Please wait a moment before trying again.'
          );
        })
        .then(() => {
          this.loading = false;
        });
    },
    togglePremiumJoin() {
      const isJoining = !this.premium.is_joining;
      return this.$store
        .dispatch('user/willJoinPremium', {
          join: isJoining
        })
        .then(() => {
          return this.$store
            .dispatch('cart/joinPremium', {
              _id: this.cart._id,
              join: isJoining,
              wishlist_id: this.cart.wishlistId
            })
            .then((res) => {
              tom.helper.ga.push([
                'event',
                'Premium',
                'Checked',
                `premium-join_check_on_review-${
                  res.premium.is_joinning ? 'on' : 'off'
                }`,
                1,
                true
              ]);
            })
            .catch((err) => {
              this.$alert(
                (err.errors && err.errors.general) ||
                  err ||
                  'An error occurred. Please wait a moment before trying again.'
              );
              this.$store.dispatch('user/willJoinPremium', {
                join: !isJoining
              });
            });
        })
        .catch((err) => {
          this.$alert(
            (err.errors && err.errors.general) ||
              err ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    },
    changeQty(params) {
      const { shipment_id, item_id, qty, wishlist_id } = params;
      this.loading = true;
      this.$store.dispatch('shipments/changeQty', {
        cart_id: this.cart._id,
        shipment_id,
        item_id,
        qty
      });
      return this.$store
        .dispatch('cart/qty', {
          id: item_id,
          qty,
          wishlist_id
        })
        .then((res) => {
          // x-tomecスキーマでアプリにデータを送る
          // ref: https://github.com/tokyootakumode/com/issues/37958
          window.tom.helper.sendCartToApp(
            this.productIds.length,
            res.cart.expire_at
          );

          if (qty) {
            tom.helper.ga.push([
              'event',
              'Cart',
              'Changed',
              `QTY_${item_id}_${qty}`,
              1
            ]);
          } else {
            tom.helper.ga.push([
              'event',
              'Cart',
              'Clicked',
              `Remove_${item_id}`,
              1
            ]);
          }
        })
        .catch((err) => {
          this.$alert(
            (err.errors && err.errors.general) ||
              err ||
              'An error occurred. Please wait a moment before trying again.'
          );
        })
        .then(() => {
          this.loading = false;
        });
    },
    formatDate(date, format = 'America/Los_Angeles') {
      if (!dayjs) {
        return date;
      }

      return dayjs.tz(date, format).format('MMM. DD, YYYY z');
    },
    setDummyAvatar(event) {
      event.target.src = urlUtil.cloudImageUrl(
        '/static/common/noAvatarImage100.png'
      );
    }
  }
};
</script>

<style scoped>
.v-container {
  min-height: 50vh;
}

.p-checkout-title {
  font-size: 2.4rem;
  margin-bottom: 0;
}

.p-checkout-section {
  background: white;
  border: 1px solid #d0d0d0;
  border-radius: 2px;
}

.p-checkout-section__content {
  margin: 24px 14px;
  flex: 1;
}

.p-checkout-section__title {
  align-items: center;
  border-bottom: 1px solid #d0d0d0;
  display: flex;
  font-size: 1.6rem;
  font-weight: bold;
  justify-content: space-between;
  padding: 14px;
}

.p-checkout-section--shipped {
  font-weight: normal;
  margin-left: 3px;
}

.p-checkout__subtitle {
  font-size: 1.6rem;
  font-weight: bold;
}

.c-tom-premium {
  width: 100px;
}

.p-checkout-text--discount {
  color: #e2041b;
}

.p-checkout-side {
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
  position: sticky;
  top: 10px;
  height: min-content;
}

.p-review-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.p-review-info-box {
  width: calc(50% - 10px);
  margin-bottom: 2rem;
}

.p-review-info-box__title {
  padding: 10px 14px;
}

.p-review-info-box__content {
  margin: 10px 14px;
}

.p-review-info-box__title {
  font-size: 1.4rem;
}

.p-shipment-info {
  display: flex;
  justify-content: space-between;
}

.p-shipment-item {
  width: 50%;
}

.p-shipment-item-fill {
  width: 100%;
}

.p-shipment-option {
  width: 50%;
}

.p-shipping-method {
}

.p-shipment-figure {
  margin-right: 10px;
}

.p-shipment-body {
  flex: 1;
}

.p-shipment-body__title a {
  color: #202020;
  font-size: 1.4rem;
  font-weight: normal;
}

.p-shipment-price--regular {
  color: #888;
  font-size: 1.4rem;
  text-decoration: line-through;
}

.p-shipment-price--selling {
  color: #b7282e;
  font-size: 1.6rem;
  font-weight: bold;
}

.p-shipment-price--premium {
  width: 90px;
}

.p-shipment-option-body {
  padding: 16px 0;
}

.p-gift-wrapping {
  border-top: 1px solid #d0d0d0;
}

.p-gift-wrapping__header {
  align-items: center;
  display: flex;
}

.p-checkout-order dt {
  width: 70%;
  font-weight: normal;
}

.p-checkout-order dd {
  width: 30%;
}

.p-checkout-order-contents {
  border: 4px solid #d0d0d0;
  margin-top: 15px;
  padding: 10px;
}

.p-checkout-order-detail {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0;
}

.p-checkout-order-detail dt {
  font-weight: normal;
  width: 70%;
}

.p-checkout-order-detail dd {
  width: 30%;
  margin-bottom: 0;
}

.p-checkout-order-detail-border {
  border-top: 1px solid #d0d0d0;
  padding-top: 5px;
}

.p-checkout-total,
.p-checkout-total + dd {
  border-top: 1px solid #d0d0d0;
  padding-top: 5px;
  padding-bottom: 5px;
}

.p-checkout-total + dd {
  color: #b7282e;
}

.p-review-import-tax {
  background: #efefef;
  margin: 10px -10px -10px;
  padding: 15px;
}

.p-review-message--primary {
  margin: 0 auto;
  max-width: 960px;
}

.p-checkout-order-premium {
  margin-top: 10px;
}

.p-checkout-order-detail .p-checkout-coupon-free-shipping-name {
  flex: 1;
  width: auto;
}

.p-checkout-order-detail .p-checkout-coupon-free-shipping-label {
  margin-left: 10px;
  min-width: 30%;
  text-align: right;
  width: auto;
}

.p-tos a {
  color: #7a7a7a;
}

@media (max-width: 767px) {
  .p-review-inner {
    padding: 0 1.5rem;
  }

  .p-review-info-box {
    border-left: none;
    border-right: none;
    border-radius: 0;
    margin-bottom: 0;
  }

  .p-review-info-box + .p-review-info-box {
    border-top: none;
  }

  .p-review-info-box .c-panel__header {
    background: #f0f0f0;
  }

  .p-review-info-box .c-btn {
    background: #fff;
  }

  .p-checkout-section {
    margin: 15px;
  }

  .p-checkout-container {
    flex-direction: column;
  }

  .p-checkout-main.col.s8,
  .p-checkout-side.col.s4 {
    width: 100%;
  }

  .p-checkout-main.col.s8 {
    padding: 0;
  }

  .p-review-info,
  .p-shipment-info {
    flex-direction: column;
  }

  .p-review-info-box,
  .p-shipment-item,
  .p-shipment-option {
    width: 100%;
  }

  .p-shipment-item {
    border-bottom: 1px solid #d0d0d0;
  }

  .p-review-message {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .p-review-import-tax {
    margin: 0 0 10px;
  }

  .p-checkout-order-contents .p-review-import-tax {
    margin: 10px 0 0;
  }

  .p-gift-wrapping__header {
    justify-content: space-between;
  }

  .p-cart-reserved__time {
    font-size: 12px;
  }

  .p-tos {
    margin-bottom: 15px;
  }

  .p-checkout-order-premium {
    border-bottom: 1px solid #d0d0d0;
    border-top: 0;
    margin-bottom: 15px;
    margin-top: 0;
    order: 1;
    padding-bottom: 15px;
    padding-top: 0;
  }

  .p-checkout-order-contents {
    border: none;
    order: 2;
    margin-top: 0;
    padding: 0;
  }

  .p-by-placing-your-order {
    order: 3;
  }

  .p-checkout-side > .c-message {
    order: 3;
  }

  .p-checkout-order {
    order: 4;
  }
}
</style>
